export default __webpack_public_path__ + "static/media/image-ph-health-home-w@2x.0661f1b2.webp";